import { PRODUCT, productAdministeredBy, workosRoleSlug } from "@myela/auth/catalog";
import type { CurrentUser } from "./accountApi";

/**
 * What a person may open, read from the roles and permissions WorkOS granted.
 *
 * Not from `userType`: that is derived from the Partner Portal role alone, so it
 * says nothing about Issuing, Gateway or the Merchant portal. Gating one
 * product on another product's role is how a merchant_viewer ended up refused
 * from the Merchant portal for being an "AGENT".
 */
export const holdsRoleIn = (user: CurrentUser | null | undefined, productKey: string): boolean =>
  (user?.productRoles ?? []).some((r) => r.startsWith(`${productKey}_`));

/** Holds a role that runs this product's team. */
export const runsProduct = (user: CurrentUser | null | undefined, productKey: string): boolean =>
  (user?.productRoles ?? []).some((r) => productAdministeredBy(r) === productKey);

/** Holds one named permission, as WorkOS names it (`merchant:sales:read`). */
export const can = (user: CurrentUser | null | undefined, permission: string): boolean =>
  (user?.permissions ?? []).includes(permission);

/** Holds a named role of a product (`'merchant', 'viewer'`). */
export const hasProductRole = (user: CurrentUser | null | undefined, productKey: string, slug: string): boolean =>
  (user?.productRoles ?? []).includes(workosRoleSlug(productKey, slug));

/** Whether the catalog knows this product at all — guards a key typo at the call site. */
export const isProduct = (productKey: string): boolean => productKey in PRODUCT;
